<template>
    <div>
      <el-collapse v-model="activecptp" >
        <el-collapse-item title="产品缩略图（必须上传,否则产品库列表不显示）" name="1">
          <el-row class="querypanel">
            <el-col :span= "8">
              <div class="queryinput">
              <el-form ref="form"  label-width="120px" label-position="top">
                <el-form-item label="上传产品缩略图" class="yyzz_upload">
                  <UpLoadFile ref="upfile" @upok="upok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifimg="ifimg" :curfilepath="curfilepath" bucketpath="ecomm/goodsimg"></UpLoadFile>
                </el-form-item>
              </el-form>
            </div>
            </el-col>
            <el-col :span= "16" >
              现有缩略图列表：
              <el-table
                :data="sltdata">
                <el-table-column
                  prop="img_url"
                  label="缩略图">
                </el-table-column>
                <el-table-column
                  prop="address"
                  width="100px"
                  label="操作">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="查看/下载缩略图" placement="top-start">
                      <i class="fa fa-eye fa-lg opicon curpointer" v-on:click="seeslt(scope.$index, sltdata)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除缩略图" placement="top-start">
                      <i class="fa fa-trash-o opicon fa-lg curpointer" v-on:click="delslt(scope.$index, sltdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="产品轮播图" name="2">
          <el-row class="querypanel">
            <el-col :span="8">
              <div class="queryinput">
                <el-form ref="form"  label-width="120px" label-position="top">
                  <el-form-item label="轮播图类型">
                    <el-select v-model="lbttype" filterable placeholder="请选择轮播图分类">
                      <el-option
                        v-for="item in lbttypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="上传轮播图" class="yyzz_upload">
                    <MUpLoadFile ref="upfile" @upmok="upmok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifallfile="ifimg" :curfilepath="curfilepath1" bucketpath="ecomm/goodsimg"></MUpLoadFile>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
            <el-col :span="16"><div class="queryinput">
              现有轮播图列表：
              <el-table
                :data="lbtdata">
                <el-table-column
                  prop="img_url"
                  label="轮播图名称">
                </el-table-column>
                <el-table-column
                  prop="address"
                  width="100px"
                  label="操作">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="查看/下载轮播图" placement="top-start">
                      <i class="fa fa-eye fa-lg opicon curpointer" v-on:click="seelbt(scope.$index, lbtdata)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除轮播图" placement="top-start">
                      <i class="fa fa-trash-o opicon fa-lg curpointer" v-on:click="dellbt(scope.$index, lbtdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div></el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import UpLoadFile from '../upload/UpLoadFile'
  import MUpLoadFile from '../upload/MUpLoadFile'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'GImg',
    components: {
      UpLoadFile,
      MUpLoadFile
    },
    data () {
      return {
        activecptp: ['1','2'],
        lbttypes: [{
          value: 1,
          label: '图片'
        }, {
          value: 2,
          label: '视频'
        }],
        lbttype: 1,
        sltdata: [],
        lbtdata: [],
        ifshowfile:false, // 上传页面参数： 是否显示文件
        curfilepath: '', // 上传页面参数： 当前选中图标文件路径
        curfilepath1: '',
        ifimg: true, // 上传页面参数： 上传方式是否设定为 图片模式
        ifupload: false, // 上传页面参数： 是否显示上传参数
        khid: '' // 所属客户ID
      }
    },
    mounted: function () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        that.$options.methods.getsltlist()
        that.$options.methods.getlbtlist()
      }
    },
    methods: {
      getsltlist () {
        var qstr = {
          whereinfo: 'pos=0 and goods_id = ' + localStorage.getItem('curgoodsid') + " and ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygimgs',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.sltdata = res.data
              that.curfilepath = that.sltdata[0].img_url
            } else {
              that.sltdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getlbtlist () {
        var qstr = {
          whereinfo: 'pos=1 and goods_id = ' + localStorage.getItem('curgoodsid') + " and ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygimgs',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.lbtdata = res.data
              that.$emit('reloaddata');
            } else {
              that.lbtdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      seeslt (index, data) {
        var curselectdata = data[index]
        window.open(curselectdata.img_url, '_blank')
      },
      delslt (index, data) {
        var curseldata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delgimgs',
          method: 'post',
          data: {
            id: curseldata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$options.methods.getsltlist()
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
        console.log(curseldata)
      },
      seelbt (index, data) {
        var curselectdata = data[index]
        window.open(curselectdata.img_url, '_blank')
      },
      dellbt (index, data) {
        var curseldata = data[index]
        console.log(curseldata)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delgimgs',
          method: 'post',
          data: {
            id: curseldata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$options.methods.getlbtlist()
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      upok (curpath,fileList) {
        that.curfilepath = curpath
        var idtmp = ''
        if (that.sltdata.length > 0) {
          idtmp = that.sltdata[0].id.toString()
        }
        var adata
        adata = {
          id: idtmp,
          goods_id: localStorage.getItem('curgoodsid').toString(),
          urltype: '1',
          img_url: curpath,
          pos: '0',
          plat: '0',
          cusid: that.khid.toString(),
          ownphone: localStorage.getItem('username')
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addgimgs',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$options.methods.getsltlist()
              that.$message({
                type: 'success',
                message: '添加成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
        window.console.log(fileList)
      },
      upmok (curpath,fileList) {
        window.console.log(fileList)
        var adata = {
          id: '',
          goods_id: localStorage.getItem('curgoodsid').toString(),
          urltype: that.lbttype.toString(),
          img_url: curpath,
          pos: '1',
          plat: '0',
          cusid: that.khid.toString(),
          ownphone: localStorage.getItem('username')
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addgimgs',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$options.methods.getlbtlist()
              that.$message({
                type: 'success',
                message: '添加成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      preaspec () {
        that.$emit('preaspec');
      },
      nextdes () {
        that.$emit('nextdes');
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newgoods/GImg.vue